import { isTypographyToken } from './is-typography-token.js';
const isBreakpointTokenObject = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        const o = obj;
        return (isTypographyToken(o.xs) &&
            isTypographyToken(o.md) &&
            isTypographyToken(o.lg) &&
            isTypographyToken(o.xl) &&
            isTypographyToken(o.xxl));
    }
    return false;
};
export const isBreakpointToken = (obj) => {
    if (typeof obj === 'object' && obj !== null) {
        const o = obj;
        return isBreakpointTokenObject(o.bp);
    }
    return false;
};
//# sourceMappingURL=is-breakpoint-token.js.map